import { render, staticRenderFns } from "./DocumentExpiredAlerts.vue?vue&type=template&id=33a8e751&"
import script from "./DocumentExpiredAlerts.vue?vue&type=script&lang=js&"
export * from "./DocumentExpiredAlerts.vue?vue&type=script&lang=js&"
import style0 from "./DocumentExpiredAlerts.vue?vue&type=style&index=0&id=33a8e751&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports